export * from './app-sidebar-footer.component';



// WEBPACK FOOTER //
// /var/www/midac/midac-live/app/src/app/components/app-sidebar-footer/index.ts